import { setConfig } from 'react-hot-loader';
setConfig({
  logLevel: 'error',
});